exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-sheet header{max-height:65px!important}.v-dialog__content--active{z-index:99998!important}.push-10{padding-left:10%!important}.push-10,.push-20{margin-top:55px!important}.push-20{padding-left:30%!important}.push-30{padding-left:20%!important}.push-30,.push-40{margin-top:55px!important}.push-40{padding-left:40%!important}.push-50{padding-left:50%!important;margin-top:55px!important}", ""]);

// exports
